<app-screen-content>
  <ng-container title>
    <span *ngIf="status === 'Success'" class="title"
      >Great, we’ve got your application!</span
    >
    <span *ngIf="status === 'Pending'" class="title"
      >Sorry, we'll need more time</span
    >
    <span *ngIf="status === 'Failed'" class="title"
      >Sorry, we're unable to verify your signature</span
    >
  </ng-container>

  <ng-container body>
    <section class="box-confirmation" *ngIf="status === 'Success'">
      <img src="assets/icons/ic-pending@3x.svg" alt="" />
      <div class="flow">Financial Needs Analysis</div>
      <div class="status">Submitted</div>
      <div class="message">
        We will inform you via email once your submission is accepted and you
        are ready to invest.
      </div>
    </section>

    <section class="box-confirmation" *ngIf="status === 'Pending'">
      <img src="assets/icons/ic-pending@3x.svg" alt="" />
      <div class="flow">Financial Needs Analysis</div>
      <div class="status pending">Pending verification</div>
      <div class="message">
        We will inform you via email regarding the submission status soon.
      </div>
    </section>

    <section class="box-confirmation" *ngIf="status === 'Failed'">
      <img src="assets/icons/ic-pending@3x.svg" alt="" />
      <div class="flow">Financial Needs Analysis</div>
      <div class="status failed">Unsuccessful submission</div>
      <div class="message">Please re-sign the document.</div>
      <app-button
        class="re-sign-btn"
        [block]="true"
        (click)="handleGoToReSignDocument()"
        >Re-sign Document</app-button
      >
    </section>
  </ng-container>
</app-screen-content>
